import { CampaignType } from '../../../__generated__/graphql'
import { useCubeQuery } from '../../../utils/hooks/useCubeQuery'

export const HIDDEN_CONVERSION_COLUMN_VALUES = ['conversions', 'cpa']

const isEligibleCampaignType = (campaign: { type: string }) =>
  campaign.type === CampaignType.Standard || campaign.type === CampaignType.MarketplaceNativeDisplay

// A campaign is considered migrated once it has registered at least one named conversion
// (leads, purchases, qualified visits, custom conversions) over its whole lifetime.
export const useShouldShowNewConversionReporting = (
  campaign: { type: string; startDate: string; _id: string },
  cubejsApi: any
) => {
  const isEligibleType = isEligibleCampaignType(campaign)

  const { resultSet } = useCubeQuery(
    {
      measures: ['aggregateTdLevel.named_conversions_count'],
      filters: [
        {
          member: 'aggregateTdLevel.campaignId',
          operator: 'equals' as const,
          values: [campaign._id],
        },
      ],
    },
    { cubejsApi, skip: !isEligibleType }
  )

  const namedConversionsCount = Number(
    (resultSet as any)?.loadResponses[0].data[0]?.['aggregateTdLevel.named_conversions_count'] || 0
  )
  return isEligibleType && namedConversionsCount > 0
}
